export default {
    model: {
        email: {
            label: "E-mail",
            placeholder: "Nome o email del delegato",
            notFound: "Utenti non trovati"
        },
        start_on: {
            label: "Data di inizio",
            placeholder: "Data di inizio della delega"
        },
        end_on: {
            label: "Data di fine",
            placeholder: "Opzionale"
        },
        accept: {
            tip: "Delegando la tua responsabilità di approvazione, certifichi di assumerti la responsabilità di tutti gli ordini approvati dal tuo delegato.",
            label: "Accetto"
        }
    },
    buttons: {
        submit: {
            cta: "Confermare",
            processing: "Risparmio"
        },
        close: {
            cta: "Cancellare"
        }
    },
    saved: "Salvato"
}